<template>
  <div>
    <v-autocomplete
      :items="formOptions"
      :value="value"
      :loading="searchLoading"
      label="Select Form"
      outlined
      @input="$emit('input', $event)"
      @update:search-input="$emit('search', $event)"
      cache-items
    ></v-autocomplete>
    <CSVDragAndDrop
      v-if="formOptions.length > 0"
      :columns="columns"
      :file="file"
      :loading="gettingFormQuestions"
      @file-selected="$emit('file-selected', $event)"
    />
  </div>
</template>

<script>
import CSVDragAndDrop from "@/components/CSVDragAndDrop.vue";

export default {
  name: "UploadCSVStep",
  components: {
    CSVDragAndDrop,
  },
  props: {
    value: {
      type: [String, Number],
      default: null,
    },
    formOptions: {
      type: Array,
      default: () => [],
    },
    gettingFormQuestions: {
      type: Boolean,
      default: false,
    },
    columns: {
      type: Array,
      default: () => [],
    },
    file: {
      type: File,
      default: null,
    },
    searchLoading: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["input", "file-selected", "search"],
};
</script>

<style scoped></style>
